import { useGetDashRecentCancelledList } from '@apps-common/apis/portal/dash'
import { UnitListCardSmSkeleton } from '@apps-common/apps/portal/pages/units/components'
import { UnitListCardSm } from '@apps-common/apps/portal/pages/units/components/UnitListCardSm'
import { PageSubtitle } from '@apps-common/components/common/portal-title'
import { ButtonRoundArrow } from '@apps-common/components/elements/button/ButtonRoundArrow'
import { commonIcons } from '@apps-common/config/icons'
import { UNIT_ORDER_DATE_DELETED, UNIT_STATUS_CANCELLED } from '@apps-common/config/unit-filter'
import { useNavigation } from '@apps-common/hooks/useNavigation'
import { AUTH_CLAIMS, Authorization } from '@apps-common/lib'
import {
  DEFAULT_MANAGEMENT_UNITS_FILTER_STORE_PROPS,
  DEFAULT_PORTAL_UNITS_FILTER_STORE_PROPS,
  useManagementUnitsFilterStore,
  usePortalUnitsFilterStore
} from '@apps-common/stores'
import { ROUTE_UNITS } from '@apps-radionet-portal/config/private-routes'
import { DashNoResultsCard } from '../DashNoResultsCard'

export const RecentCancellationsCard = () => {
  const { navigateRoot } = useNavigation()
  const { setTempState: setPortalTempState } = usePortalUnitsFilterStore()
  const { setTempState: setManagementTempState } = useManagementUnitsFilterStore()
  const { isLoading, isError, data } = useGetDashRecentCancelledList({ config: {}, take: 6 })

  const loading = isLoading || isError || !data

  return (
    <div className='relative sm:bg-surface-2 w-full h-[100%] sm:rounded-3xl overflow-y-hidden scrollbar-none sm:border border-border'>
      <div className='absolute z-[55] top-0 left-0 pt-4 px-6 sm:pt-7 sm:px-7 pb-[10px] w-full sm:rounded-t-3xl backdrop-blur'>
        <div className='flex items-center justify-between'>
          <PageSubtitle classes='text-text '>Recent cancellations</PageSubtitle>
          <Authorization
            roles={AUTH_CLAIMS.managementAdmin.roles}
            scopes={AUTH_CLAIMS.managementAdmin.scopes}
            notAuthorizedFallback={
              <ButtonRoundArrow
                disabled={loading}
                classes='bg-brand'
                iconClasses='text-on-brand'
                callback={() => {
                  setPortalTempState({
                    ...DEFAULT_PORTAL_UNITS_FILTER_STORE_PROPS,
                    status: UNIT_STATUS_CANCELLED.value as string,
                    orderBy: UNIT_ORDER_DATE_DELETED.value as string
                  })
                  navigateRoot({ routeUrl: ROUTE_UNITS.buildPath(), route: ROUTE_UNITS })
                }}
                tooltip={{
                  id: `dashboard-recent-cancellations-view-all-portal-tooltip`,
                  message: 'View all'
                }}
              />
            }
          >
            <ButtonRoundArrow
              disabled={loading}
              classes='bg-brand'
              iconClasses='text-on-brand'
              callback={() => {
                setManagementTempState({
                  ...DEFAULT_MANAGEMENT_UNITS_FILTER_STORE_PROPS,
                  status: UNIT_STATUS_CANCELLED.value as string,
                  orderBy: UNIT_ORDER_DATE_DELETED.value as string
                })
                navigateRoot({ routeUrl: ROUTE_UNITS.buildPath(), route: ROUTE_UNITS })
              }}
              tooltip={{
                id: `dashboard-recent-cancellations-view-all-management-tooltip`,
                message: 'View all'
              }}
            />
          </Authorization>
        </div>
      </div>
      <div className='relative z-[1] flex items-center justify-start flex-nowrap overflow-x-auto sm:grid sm:grid-cols-3 sm:overflow-visible gap-[10px] !pt-[70px] sm:!pt-[85px] px-5 sm:p-8 scrollbar-none'>
        {!loading && data?.length === 0 && (
          <DashNoResultsCard Icon={commonIcons.cancel}>You have no recent cancellations.</DashNoResultsCard>
        )}
        {loading &&
          Array.from(Array(6).keys()).map((k, i) => (
            <UnitListCardSmSkeleton
              key={`recent-cancellations-skeleton-${k}`}
              index={i}
              bgClasses='bg-skeleton min-w-[200px] sm:min-w-[185px] border border-skeleton-border'
              textClasses=''
              iconClasses=''
              bgSecondaryClasses='bg-skeleton-hi'
              textSecondaryClasses=''
              bgTertiaryClasses='bg-skeleton-hi'
            />
          ))}
        {!loading &&
          data
            ?.slice(0, 6)
            ?.map((d, i) => (
              <UnitListCardSm
                key={`recent-cancellations-${d.unitId}-${i}`}
                bgClasses='bg-surface min-w-[200px] sm:min-w-[185px] border border-border'
                textClasses='text-text'
                iconClasses='text-text-muted'
                bgSecondaryClasses='bg-surface-2'
                textSecondaryClasses='text-text-muted'
                bgTertiaryClasses='bg-surface'
                unit={d}
              />
            ))}
        <div className='w-2 shrink-0 sm:hidden' />
      </div>
    </div>
  )
}
